import React from "react";
import style from './Pages.module.css'
import Footer from "../components/layouts/footer/Footer";
import Header from "../components/layouts/header/Header";
import Faqcontent from "../components/faq/faq";

const faqs = (props) => {
    // console.log("Home props", props);

    //mixins.setStore("loading",true,props);
    return (<div className={style['container']}>
        <Header current={props.location.pathname} />
        <div className={style['cmsmin_height']}>
            <Faqcontent />
        </div>
        <Footer />
    </div>)
}
export default connect(faqs);